import { useEffect, useMemo } from 'react'
import get from 'lodash/get'
import {
  trackProductDetailView,
  trackProductImpressionAndAction,
} from '@utils/gtm'
import { ProductVariant } from '@pageFeatures/design/designUpload/types'
import { useIsDataLayerReady } from '@framework/common/use-gtm-initialise'

export function useProductTrackingEvents(
  selectedOptionLabel: string,
  productOption: ProductVariant,
  productName: string
) {
  const dataLayerIsReady = useIsDataLayerReady()

  const trackingData = useMemo(() => {
    const customUrl = productOption?.customUrl?.url
      ?.split('/')
      ?.filter(Boolean)
      .filter((element) => !element.includes('?') && !element.includes('#'))
    customUrl?.pop()
    const categorySlug = customUrl?.pop()
    const optionValues = get(productOption, 'optionValues', [])

    return {
      currencyCode: productOption.currencyCode,
      name: productName,
      sku: productOption.variantSku,
      price: productOption.price,
      quantity: productOption.quantity,
      categorySlug: categorySlug,
      optionValues: optionValues,
    }
  }, [productOption])

  useEffect(() => {
    if (selectedOptionLabel) {
      trackProductImpressionAndAction(selectedOptionLabel, trackingData)
    }
  }, [selectedOptionLabel])

  useEffect(() => {
    if (dataLayerIsReady) {
      trackProductDetailView(trackingData)
    }
  }, [dataLayerIsReady])

  return trackingData
}
